import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-site-maintenance',
  templateUrl: './site-maintenance.component.html',
  styleUrls: ['./site-maintenance.component.scss']
})
export class SiteMaintenanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/site-maintenance/site-maintenance.component.ts